import React from "react";
import { Typography } from "@mui/material";

interface NoDataAvailableProps {
  message?: string;
  align?: "inherit" | "left" | "center" | "right" | "justify";
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2"
    | "caption"
    | "button"
    | "overline";
}

const NoDataAvailable: React.FC<NoDataAvailableProps> = ({
  message = "No Data Available",
  align = "center",
  variant = "body1"
}) => {
  return (
    <Typography
      align={align}
      variant={variant}
      sx={{
        fontSize: "18px",
        fontWeight: 600,
        lineHeight: 1.25,
        fontFamily: "Montserrat, sans-serif",
        fontStyle: "normal",
        color: "var(--light-text-primary, #192F67)",
        mb: "0.35em"
      }}
    >
      {message}
    </Typography>
  );
};

export default NoDataAvailable;
